<template>
  <div>
    <div
      v-if="
        !Permit.isFreeEdition() &&
        Permit.currentTenant().chargeW.availableDays < 15
      "
      class="center"
      style="background: red; color: #fff; padding: 2px 0"
    >
      系统还有
      {{ Permit.currentTenant().chargeW.availableDays }}
      天到期，请联系客服续费，以免影响使用
    </div>
    <div class="wrapper">
      <breadcrumb :crumbs="['主工作台']"> </breadcrumb>

      <div style="display: flex; justify-content: space-between">
        <div class="mgr20" style="flex: 1; min-width: 0">
          <rent-package source="dashboard" class="mgb20"></rent-package>
          <rent-workbench class="mgb20"></rent-workbench>
        </div>
        <div
          style="
            width: 400px;
            flex-direction: column;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          <div>
            <el-button
              type="success"
              style="width: 100%"
              class="mgb10"
              @click="$router.push('/normal/portals/rent-calendar')"
            >
              {{ $t("action.rentCalendar") }}
            </el-button>
          </div>
          <rented-count class="mgb10"></rented-count>
          <div>
            <el-button
              v-if="Permit.canActions('dashboardWmsSearchSchedule')"
              type="primary"
              style="width: 100%"
              class="mgb10"
              @click="$router.push('/normal/wms/search-schedule')"
            >
              {{ $t("action.searchSchedule") }}
            </el-button>
          </div>

          <div>
            <el-button
              v-if="Permit.canActions('dashboardWmsSearchUsableBySchedule')"
              type="primary"
              style="width: 100%"
              class="mgb10"
              @click="$router.push('/normal/wms/search-usable-by-schedule')"
            >
              {{ $t("action.searchUsableBySchedule") }}
            </el-button>
          </div>

          <today-schedule
            v-if="Permit.canActions('scheduleView')"
            class="mgb10"
          ></today-schedule>
          <service-items v-if="Permit.canActions('rentView')"></service-items>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('text.perfectInformation')"
      :visible.sync="perfectInformationDF"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
    >
      <el-form
        ref="perfectInformationObjForm"
        :model="perfectInformationObj"
        label-width="80px"
      >
        <el-form-item
          :label="$t('tenant.name')"
          prop="tenantName"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('tenant.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="perfectInformationObj.tenantName"
          />
        </el-form-item>
        <el-form-item
          :label="$t('user.name')"
          prop="userName"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="perfectInformationObj.userName"
          />
        </el-form-item>
        <el-form-item
          :label="$t('tenant.province')"
          prop="province"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('tenant.province')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="perfectInformationObj.province"
          />
        </el-form-item>
        <el-form-item
          :label="$t('tenant.city')"
          prop="city"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('tenant.city')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="perfectInformationObj.city" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="perfectInformationDoing"
          size="small"
          @click="perfectInformationSubmit"
          >{{ $t("text.submit") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import ls from "store2";
import Cookies from "js-cookie";
import RawHtml from "@/components/RawHtml";
import User from "@/api/user";
import RentPackage from "./portals/RentPackage";
import RentWorkbench from "./portals/RentWorkbench";
import TodaySchedule from "./portals/TodaySchedule";
import ServiceItems from "./portals/ServiceItems";
import RentedCount from "./portals/RentedCount";
import RentCalendar from "./portals/RentCalendar";

export default {
  mixins: [page],
  components: {
    RawHtml,
    RentPackage,
    RentWorkbench,
    TodaySchedule,
    ServiceItems,
    RentedCount,
    RentCalendar,
  },
  data() {
    return {
      // 完善信息
      perfectInformationDF: false,
      perfectInformationObj: {
        userName: null,
        tenantName: null,
        industry: "婚纱礼服",
        province: null,
        city: null,
      },
      perfectInformationDoing: false,
      //
      sysLog: { createAt: null },
      systemUpdateReadDF: false,
      sysNoticeDF: false,
      //
      rentedCount: 0,
    };
  },

  created() {
    const self = this;
    if (
      self.Permit.currentTenant().name == null &&
      self.Permit.currentUser().admin === true
    ) {
      self.perfectInformationDF = true;
    } else {
      self.perfectInformationDF = false;
    }
  },
  methods: {
    //=====
    clickReadSystemUpdate() {
      Cookies.set("sysLogLastCreateAt", this.sysLog.createAt);
      this.$router.push({
        name: "sysLogs",
      });
    },
    clickSystemUpdateClose() {
      this.sysNoticeDF = false;
      Cookies.set("sysLogLastCreateAt", this.sysLog.createAt);
    },

    // 完善信息
    perfectInformationSubmit() {
      const self = this;
      this.$refs.perfectInformationObjForm.validate((valid) => {
        if (valid) {
          self.perfectInformationDoing = true;
          User.updateInfo(
            self.Permit.currentUser().id,
            self.perfectInformationObj
          ).then(function (res) {
            if (res && res.status === 200) {
              self.perfectInformationDoing = false;
              self.perfectInformationDF = false;
              self.$message({
                message: self.$t("prompt.perfectInformationSuccess"),
                type: "success",
              });
              self.getUser();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getUser() {
      const self = this;
      User.findById(self.Permit.currentUser().id).then(function (res) {
        if (res.data.code === 200) {
          // self.user = res.data.entity;
          // self.tenant = res.data.entity.tenant;
          ls.session("TENANT", res.data.entity.tenant);
          ls.session("USER", res.data.entity);
          // store.dispatch("setTenant", res.data.entity.tenant);
          // store.dispatch("setUser", res.data.entity);
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style>
</style>


